<div class='risk-heat-bar {{version}}' data-placement="top" data-toggle="tooltip" [attr.title]='tooltip'
  [template]='template' enTooltip>
  <div class='risk-heat-bar-label {{version}} {{ riskNormalized }}'>
    {{ riskLabel }}
  </div>
</div>